/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys, Topic } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'
import { useUpdateNote } from './useUpdateNote'
import { TopicApplication } from '@/utils/constants'

interface UpdateTopicParams {
  topicName: string
  topic: Topic
}

export const useUpdatePatternTopic = () => {
  const axios = useContext(AxiosContext)
  const { updateTopicList } = useAppStore()
  const [topicList] = useAppStore((state) => [state.home.topicList], shallow)
  const updateTopicNote = useUpdateNote()
  return useMutation({
    mutationKey: [ReactQueryKeys.UPDATE_TOPIC],
    mutationFn: async ({ topic, topicName }: UpdateTopicParams) => {
      // No need to call 2 apis to rename the topic, just update first note and use first note noteText for display

      const { topicID } = topic
      const updatedTopic = { ...topic, topicName }
      const response = await axios.api.post('ajax/topics', {
        requestType: 'topicUpdate',
        'topicData[action]': 'update',
        'topicData[topicApplication]': TopicApplication.Oddlyou,
        'topicData[topicName]': topicName,
        'topicData[topicDescription]': '',
        'topicData[topicID]': topicID,
        format: 'json',
      })

      // const topic = topicList[topicID]

      updateTopicList({
        [topicID]: updatedTopic,
      })

      /*
      const { firstNote } = topic
      if (firstNote) {
        const noteText = {
          text: `<p>${topicName}</p>`,
          attachments: [],
        }
        await updateTopicNote.mutateAsync({
          noteID: firstNote.noteID,
          topicID,
          noteText: JSON.stringify(noteText),
          egoList: firstNote.egoList,
        })
      }
      */

      return response
    },
  })
}
